const products = 
[{
  id: '1',
  title: "Fjallraven - Foldsack No. 1 Backpack, Fits 15 Laptops",
  price: 880,
  content: "Your perfect pack for everyday use and walks in the forest. Stash your laptop (up to 15 inches) in the padded sleeve, your everyday",
  quantity: 6,
  img: "https://res.cloudinary.com/drddmdkvv/image/upload/v1616444721/1_z16mf2.jpg"
}, {
  id: '2',
  title: "Mens Casual Premium Slim Fit T-Shirts ",
  price: 900,
  content: "Slim-fitting style, contrast raglan long sleeve, three-button henley placket, light weight & soft fabric for breathable and comfortable wearing. And Solid stitched shirts with round neck made for durability and a great fit for casual fashion wear and diehard baseball fans. The Henley style round neckline includes a three-button placket.",
  quantity: 6,
  img: "https://res.cloudinary.com/drddmdkvv/image/upload/v1616444721/2_eq65ap.jpg"
}, {
  id: '3',
  title: "Mens Cotton Jacket",
  price: 1500,
  content: "great outerwear jackets for Spring/Autumn/Winter, suitable for many occasions, such as working, hiking, camping, mountain/rock climbing, cycling, traveling or other outdoors. Good gift choice for you or your family member. A warm hearted love to Father, husband or son in this thanksgiving or Christmas Day.",
  quantity: 6,
  img: "https://res.cloudinary.com/drddmdkvv/image/upload/v1616444721/3_l34xth.jpg"
}, {
  id: '4',
  title: "Mens Casual Slim Fit",
  price: 3410,
  content: "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product content.",
  quantity: 6,
  img: "https://res.cloudinary.com/drddmdkvv/image/upload/v1616444721/4_ny48x1.jpg"
}, {
  id: '5',
  title: "John Hardy Women's Legends Naga Gold & Silver Dragon Station Chain Bracelet",
  price: 999,
  content: "From our Legends Collection, the Naga was inspired by the mythical water dragon that protects the ocean's pearl. Wear facing inward to be bestowed with love and abundance, or outward for protection.",
  quantity: 9,
  img: "https://res.cloudinary.com/drddmdkvv/image/upload/v1616444721/5_rgtsar.jpg"
}, {
  id: '6',
  title: "Solid Gold Petite Micropave ",
  price: 4500,
  content: "Satisfaction Guaranteed. Return or exchange any order within 30 days.Designed and sold by Hafeez Center in the United States. Satisfaction Guaranteed. Return or exchange any order within 30 days.",
  quantity: 9,
  img: "https://res.cloudinary.com/drddmdkvv/image/upload/v1616444722/6_ogwvn2.jpg"
}, {
  id: '7',
  title: "White Gold Plated Princess",
  price: 1674,
  content: "Classic Created Wedding Engagement Solitaire Diamond Promise Ring for Her. Gifts to spoil your love more for Engagement, Wedding, Anniversary, Valentine's Day...",
  quantity: 9,
  img: "https://res.cloudinary.com/drddmdkvv/image/upload/v1616444721/7_aryqlq.jpg"
}, {
  id: '8',
  title: "Pierced Owl Rose Gold Plated Stainless Steel Double",
  price: 9143,
  content: "Rose Gold Plated Double Flared Tunnel Plug Earrings. Made of 316L Stainless Steel",
  quantity: 9,
  img: "https://res.cloudinary.com/drddmdkvv/image/upload/v1616444721/7_aryqlq.jpg"
}]

export default products;

